import { render, staticRenderFns } from "./LeadPane.vue?vue&type=template&id=12bcb2d4"
import script from "./LeadPane.vue?vue&type=script&lang=js"
export * from "./LeadPane.vue?vue&type=script&lang=js"
import style0 from "./LeadPane.vue?vue&type=style&index=0&id=12bcb2d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports